


































































































































































































































































































































































































































































































































import { mixins } from "vue-class-component";
import WeMixin from "@/components/weMixin";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";
import {
  Form,
  Calendar,
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  List,
  Button,
  Cell,
  Picker,
  CellGroup,
  SwipeCell,
  ActionSheet,
  Dialog,
  Popup,
  DatetimePicker,
  Image,
  Collapse,
  CollapseItem,
  Divider,
} from "vant";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";
import { Toast, Panel } from "vant";
import { Icon } from "vant";
import { Loading } from "vant";
import { PullRefresh, Grid, GridItem, Card, Tabbar, TabbarItem } from "vant";
import Axios, { AxiosResponse } from "axios";
import moment from "moment";
import { RegisterInfo } from "../user/UserApi";
import { SignupInfo } from "./SignupApi";

@Component({
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Picker.name]: Picker,
    [List.name]: List,
    [Panel.name]: Panel,
    [Calendar.name]: Calendar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Loading.name]: Loading,
    [Dialog.name]: Loading,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [SwipeCell.name]: SwipeCell,
    [ActionSheet.name]: ActionSheet,
    [Image.name]: Image,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
})
export default class SignupList extends mixins(WeMixin, Jssdk) {
  private navbarClass: string = "navbar1";
  private active: number = 1;
  private activeColor: string = process.env.VUE_APP_COLOR as string;
  private rTime: number = 0;
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private signupInfo: SignupInfo = {} as SignupInfo;
  private buttonActive: boolean = false;
  private showConfirmDialog: boolean = false;
  private showResultDialog: boolean = false;
  private msg: string = "";

  private wgSignupMsg: string = "";

  private toMyUserUrl: string = "";

  protected created() {
    this.listInit();
  }
  protected listInit() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        this.registerInfo = res.data;
        this.buttonActive = true;
        this.signupInfo.username = this.registerInfo.username;
        this.signupInfo.idno = this.registerInfo.idno;
        this.signupInfo.phone = this.registerInfo.phone;
        this.signupInfo.openid = this.registerInfo.openid;
        this.signupInfo.orgid = this.registerInfo.orgid;
        this.signupInfo.orgname = this.registerInfo.orgname;
        this.checkWgSignupInfo(this.signupInfo.openid);
        if (res.data.accounttype === "0") {
          this.toMyUserUrl = "/main/user/userInfo";
        } else if (res.data.accounttype === "1") {
          this.toMyUserUrl = "/main/user/userInfoMerchant";
        }
      } else if (res.data.flag === "1") {
        this.buttonActive = false;
        const interval = window.setInterval(() => {
          if (--this.rTime <= 0) {
            window.clearInterval(interval);
            this.$router.replace("/main/user/register");
          }
        }, 2000);
      }
    });
  }
  protected wgSignup() {
    if (this.buttonActive) {
      this.showConfirmDialog = true;
      this.signupInfo.activityid = "1";
    } else {
      this.$toast("尚未注册，无法报名");
    }
  }
  protected signup() {
    api
      .post("/weixinmp/xsyx/signup/activitySignup", this.signupInfo)
      .then((res: any) => {
        this.showResultDialog = true;
        this.msg = res.data.msg;
        this.checkWgSignupInfo(this.signupInfo.openid);
      });
  }
  protected checkWgSignupInfo(id: string) {
    api
      .post("/weixinmp/xsyx/signup/checkWgSignupInfo", { openid: id })
      .then((res: any) => {
        this.wgSignupMsg = res.data.msg;
      });
  }
  protected kjzfdbRaffle() {
    const lastMonth = moment().subtract(31, "days").format("YYYYMM");
    const todayDay = moment().format("DD HH");
    if (todayDay < "10 09") {
      this.$toast({
        message: "本期抽奖活动尚未开始，请10号9:00之后再试！",
        position: "bottom",
      });
    } else {
      this.$router.replace("/main/coupon/getCouponFromNotify/2&E");
    }
  }
  protected toNotice() {
    window.location.href = "https://mp.weixin.qq.com/s/porTyT6luGv3RqTZqWoIVQ";
  }
  protected toFollowNotice() {
    window.location.href = "https://mp.weixin.qq.com/s/jm45mlz-4fvKkJvgq4kLBg";
  }
  protected followRaffle() {
    this.$router.replace("/main/raffle/followRaffleHome");
  }
  protected kjsmchRaffle() {
    this.$router.replace("/main/kjsmch/getKjsmchCoupon/3");
  }
  protected gwjRaffle() {
    this.$router.replace("/main/xjqy/xjqyHome");
  }
  protected shdbRaffle() {
    const lastMonth = moment().subtract(31, "days").format("YYYYMM");
    const todayDay = moment().format("DD HH");
    if (todayDay < "10 09") {
      this.$toast({
        message: "本期抽奖活动尚未开始，请10号9:00之后再试！",
        position: "bottom",
      });
    } else {
      this.$router.replace("/main/shdb/shdbCoupon/4");
    }
  }

  protected toKjsmchNotice() {
    window.location.href = "https://mp.weixin.qq.com/s/jm45mlz-4fvKkJvgq4kLBg";
  }

  protected sbzf() {
    // this.$router.replace("/main/signup/hdqrcode");
    // window.location.href = "#小程序://多点/I188E3EifKjypqe";
    window.location.href =
      "https://ycst.100qu.net/#/?bqkey=sb&origin=yzlife&act=h5";
  }

  protected szrmb() {
    this.$router.replace("/main/signup/hdqrcode");
  }

  protected flj() {
    window.location.href =
      "https://wap.psbc.com/mobilebank/skipCellPhoneAPPToActivityPage.do?pageId=1374";
  }

  protected nyjwsl() {
    const beginday = moment().format("YYYYMMDD HH");
    const todayDay = moment().format("YYYYMMDD");
    if (todayDay > "20240531" || beginday < "20240510 09") {
      this.$toast({
        message: "请在5月10日9点-5月31日间进行抽奖",
        position: "bottom",
      });
    } else {
      this.$router.replace("/main/nyjwsl/nyjwslCoupon/5");
    }
  }

  protected txylRaffle() {
    const todayDay = moment().format("DD HH");
    if (todayDay < "10 09") {
      this.$toast({
        message: "本期抽奖活动尚未开始，请10号9:00之后再试！",
        position: "bottom",
      });
    } else {
      this.$router.replace("/main/txyl/txylCoupon/6");
    }
  }

  protected yfq() {
    window.location.href =
      "https://wap.psbc.com/mobilebank/skipCellPhoneAPPToActivityPage.do?activityId=208672620404736&source=0&pageId=1145";
  }

  protected yyg() {
    window.location.href =
      "https://wap.psbc.com/mobilebank/skipCellPhoneAPPToActivityPage.do?activityId=181142023340032&source=0&pageId=1145";
  }
}
